import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        // 控制主菜单激活态
        navActiveIndex: '/home/',
        subNavActiveIndex: '/prod/1/'
    },
    mutations: {
        // 控制主菜单激活态
        setMainNavState (state, payload) {
            state.navActiveIndex = payload.toString()
        },
        // 控制二级菜单激活态
        setSubNavState (state, payload) {
            state.subNavActiveIndex = payload.toString()
        }
    },
    actions: {
        // 控制主菜单激活态
        setMainNav (context, payload) {
            context.commit('setMainNavState', payload)
        },
        // 控制二级菜单激活态
        setSubNav (context, payload) {
            context.commit('setSubNavState', payload)
        }
    },
    modules: {
    }
})
